(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Switch } from '@material-ui/core';
import { Div, Flex } from "../layout";
import { Label } from "../forms";
import { HelpText } from "../text";
import { SPACE } from "../../constants/style";
var ToggleContainer = styled(Flex).withConfig({
  displayName: "Toggle__ToggleContainer",
  componentId: "sc-at4kt6-0"
})(["max-width:100%;", ";"], function (props) {
  return props.fullWidth && 'width: 100%';
});
var StyledLabel = styled(Label).withConfig({
  displayName: "Toggle__StyledLabel",
  componentId: "sc-at4kt6-1"
})(["font-weight:bold !important;"]);
var StyledFlex = styled(Flex).withConfig({
  displayName: "Toggle__StyledFlex",
  componentId: "sc-at4kt6-2"
})([":nth-child(1){min-height:24px;align-items:center;}"]);

var Toggle = function Toggle(props) {
  var label = props.label,
      helpText = props.helpText,
      onChange = props.onChange,
      checked = props.checked,
      disabled = props.disabled,
      testSelector = props.testSelector,
      rest = _objectWithoutProperties(props, ["label", "helpText", "onChange", "checked", "disabled", "testSelector"]);

  return React.createElement(ToggleContainer, _extends({
    direction: "column"
  }, rest), React.createElement(Flex, {
    alignItems: "flex-start"
  }, React.createElement(Switch, {
    inputProps: {
      'data-test-selector': testSelector || label
    },
    color: "default",
    onChange: onChange,
    checked: checked,
    disabled: disabled
  }), React.createElement(Flex, {
    flexDirection: "column",
    marginLeft: "21px"
  }, label ? React.createElement(StyledFlex, {
    flex: "0 0 auto"
  }, React.createElement(StyledLabel, null, label)) : null, helpText ? React.createElement(StyledFlex, {
    flex: "0 0 auto"
  }, React.createElement(HelpText, {
    style: {
      margin: 0
    }
  }, helpText)) : null)));
};

Toggle.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool
};
Toggle.defaultProps = {
  onChange: function onChange() {
    console.warn('No onChange provided to Toggle component');
  },
  disabled: false,
  fullWidth: false
};
var _default = Toggle;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ToggleContainer, "ToggleContainer", "/home/vsts/work/1/s/src/components/inputs/Toggle.js");
  reactHotLoader.register(StyledLabel, "StyledLabel", "/home/vsts/work/1/s/src/components/inputs/Toggle.js");
  reactHotLoader.register(StyledFlex, "StyledFlex", "/home/vsts/work/1/s/src/components/inputs/Toggle.js");
  reactHotLoader.register(Toggle, "Toggle", "/home/vsts/work/1/s/src/components/inputs/Toggle.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/Toggle.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();